// extracted by mini-css-extract-plugin
export default {"OnboardingSplashscreen":"tgv5kfL_oQ0oEc44bfvr","OnboardingSplashscreen__Container":"GOxxy4KLAdsUjYG5wHf0"};